import { defineMessages } from 'react-intl'

const scope =
  'procurify.modules.purchasing.feature-sets.CatalogAccessSettingsView'

export default defineMessages({
  catalockHeading: {
    id: `${scope}.catalockHeading`,
    defaultMessage: 'Catalock',
  },
  catalockDescription: {
    id: `${scope}.catalockDescription`,
    defaultMessage:
      'When activated, all new items created in the product catalog will be locked and unable to be edited when making a request.',
  },
  catalockToggleAriaLabel: {
    id: `${scope}.catalockToggleAriaLabel`,
    defaultMessage: 'Catalock default',
  },
  lockAllHeading: {
    id: `${scope}.lockAllHeading`,
    defaultMessage: 'Catalock all existing catalog items',
  },
  lockAllDescription: {
    id: `${scope}.lockAllDescription`,
    defaultMessage: 'Restricts edits for existing catalog items in a request.',
  },
  lockAllButton: {
    id: `${scope}.lockAllButton`,
    defaultMessage: 'Lock all',
  },
  unlockAllHeading: {
    id: `${scope}.unlockAllHeading`,
    defaultMessage: 'Remove Catalock for all existing catalog items',
  },
  unlockAllDescription: {
    id: `${scope}.unlockAllDescription`,
    defaultMessage:
      'Remove restrictions on edits for all existing items in a request.',
  },
  unlockAllButton: {
    id: `${scope}.unlockAllButton`,
    defaultMessage: 'Unlock all',
  },
  catalogPermissionsHeading: {
    id: `${scope}.catalogPermissionsHeading`,
    defaultMessage: 'Catalog permissions',
  },
  catalogPermissionsDescription1: {
    id: `${scope}.catalogPermissionsDescription1`,
    defaultMessage:
      'When activated, user access will have restrictions to {pluralSecondaryOrgCategoryLabel} in the catalog.',
  },
  catalogPermissionsDescription2: {
    id: `${scope}.catalogPermissionsDescription2`,
    defaultMessage:
      'On initial activation, users will have no access to {pluralSecondaryOrgCategoryLabel} in the catalog. You will have to assign {singularSecondaryOrgCategoryLabel} access to users. Keep this feature off to give users all {singularSecondaryOrgCategoryLabel} access.',
  },
  catalogPermissionsToggleAriaLabel: {
    id: `${scope}.catalogPermissionsToggleAriaLabel`,
    defaultMessage: 'Catalog permissions',
  },
  tabUsers: {
    id: `${scope}.tabUsers`,
    defaultMessage: 'Users',
  },
  tabSecondaryCategories: {
    id: `${scope}.tabSecondaryCategories`,
    defaultMessage: '{pluralSecondaryOrgCategoryLabel}',
  },
  permissionsOffPlaceholder: {
    id: `${scope}.permissionsOffPlaceholder`,
    defaultMessage:
      'Turn on Catalog permissions to assign catalog access to users and {pluralSecondaryOrgCategoryLabel}.',
  },
  loadError: {
    id: `${scope}.loadError`,
    defaultMessage:
      'Something went wrong while loading these settings. Please refresh the page to try again.',
  },
  lockAllModalHeader: {
    id: `${scope}.lockAllModalHeader`,
    defaultMessage: 'Lock all catalog items',
  },
  lockAllModalContent: {
    id: `${scope}.lockAllModalContent`,
    defaultMessage:
      'This will restrict edits for every existing catalog item in a request. Are you sure you want to continue?',
  },
  lockAllModalConfirmButton: {
    id: `${scope}.lockAllModalConfirmButton`,
    defaultMessage: 'Lock all',
  },
  lockAllModalCancelButton: {
    id: `${scope}.lockAllModalCancelButton`,
    defaultMessage: 'Cancel',
  },
  unlockAllModalHeader: {
    id: `${scope}.unlockAllModalHeader`,
    defaultMessage: 'Unlock all catalog items',
  },
  unlockAllModalContent: {
    id: `${scope}.unlockAllModalContent`,
    defaultMessage:
      'This will remove edit restrictions from every existing catalog item in a request. Are you sure you want to continue?',
  },
  unlockAllModalConfirmButton: {
    id: `${scope}.unlockAllModalConfirmButton`,
    defaultMessage: 'Unlock all',
  },
  unlockAllModalCancelButton: {
    id: `${scope}.unlockAllModalCancelButton`,
    defaultMessage: 'Cancel',
  },
  toggleOn: {
    id: `${scope}.toggleOn`,
    defaultMessage: 'On',
  },
  toggleOff: {
    id: `${scope}.toggleOff`,
    defaultMessage: 'Off',
  },
})
